var globalObject = require('global-object');
var NativeCustomEvent = globalObject.CustomEvent;

function useNative () {
  try {
    var p = new NativeCustomEvent('cat', { detail: { foo: 'bar' } });
    return  'cat' === p.type && 'bar' === p.detail.foo;
  } catch (e) {
  }
  return false;
}

/**
 * Cross-browser `CustomEvent` constructor.
 *
 * https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent.CustomEvent
 *
 * @public
 */

var CustomEvent;
if (useNative()) {
  CustomEvent = NativeCustomEvent;
} else if (!globalObject.document) {
  CustomEvent = undefined;
} else if ('function' === typeof globalObject.document.createEvent) {
  // IE >= 9
  CustomEvent = function (type, params) {
    var e = globalObject.document.createEvent('CustomEvent');
    if (params) {
      e.initCustomEvent(type, params.bubbles, params.cancelable, params.detail);
    } else {
      e.initCustomEvent(type, false, false, void 0);
    }
    return e;
  }
} else {
  // IE <= 8
  CustomEvent = function (type, params) {
    var e = globalObject.document.createEventObject();
    e.type = type;
    if (params) {
      e.bubbles = Boolean(params.bubbles);
      e.cancelable = Boolean(params.cancelable);
      e.detail = params.detail;
    } else {
      e.bubbles = false;
      e.cancelable = false;
      e.detail = void 0;
    }
    return e;
  }
}
module.exports = CustomEvent;



//////////////////
// WEBPACK FOOTER
// ./~/custom-event-universal/index.js
// module id = 206
// module chunks = 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 30 31 32 33 34 35 36 37 38 39 40 41 42 43 44 45 46 47 48 49 50 51 52 53 54 55 56